<section class="requirements-funnel" [attr.aria-labelledby]="headingId">
  <to-section-title
    [headingId]="headingId"
    [title]="'liveDashboard.testmanager.funnel.title' | translate"
    [subtitle]="'liveDashboard.testmanager.funnel.subtitle' | translate"
  />

  <div class="requirements-funnel__list">
    @for (group of groups(); track group.projectId) {
      <div class="requirements-funnel__group">
        <a
          class="requirements-funnel__row-link"
          [routerLink]="group.requirementsLink"
          [attr.aria-label]="'liveDashboard.testmanager.funnel.toProjectRequirements' | translate: { name: group.name }"
        >
          <span
            class="requirements-funnel__dot"
            [style.background]="'var(' + group.colorVar + ')'"
            aria-hidden="true"
          ></span>
          <span class="requirements-funnel__name-text">{{ group.name }}</span>
          <mat-icon class="requirements-funnel__chevron" fontSet="material-icons-outlined" aria-hidden="true">
            chevron_right
          </mat-icon>
        </a>

        <div class="requirements-funnel__grid">
          @for (tile of group.tiles; track tile.status) {
            <a
              class="requirements-funnel__tile"
              [routerLink]="group.requirementsLink"
              [queryParams]="{ status: tile.status }"
              [style.background]="tile.tint"
              [style.border]="'1px solid ' + tile.border"
              [attr.aria-label]="
                'liveDashboard.testmanager.funnel.openAria'
                  | translate: { status: tile.label, count: tile.count, project: group.name }
              "
            >
              <div class="requirements-funnel__tile-head">
                <span class="requirements-funnel__tile-dot" [style.background]="tile.dot" aria-hidden="true"></span>
                <span class="requirements-funnel__label">{{ tile.label }}</span>
              </div>
              <div class="requirements-funnel__value">{{ tile.count }}</div>
            </a>
          }
        </div>

        @if (group.withoutStatusCount > 0) {
          <p class="requirements-funnel__without-status">
            {{
              'liveDashboard.testmanager.funnel.withoutStatus'
                | translate: { count: group.withoutStatusCount, project: group.name }
            }}
          </p>
        }
      </div>
    }
  </div>
</section>
